import React from 'react';
import PropTypes from 'prop-types';

// let top = clientY + window.scrollY + 15;
// let left = clientX + window.scrollX + 15;
// I never managed to get this kind of UI placement right
// looks like scroll doesn't affect coords here ?
let _top = ({ ref, clientY }) => {
    if (!ref.current) {
        return clientY + 15;
    }

    let rect = ref.current.getBoundingClientRect();
    if (rect.height + clientY > window.innerHeight) {
        return clientY - 15 - rect.height;
    }

    return clientY + 15;
};

let _left = ({ ref, clientX }) => {
    if (!ref.current) {
        return clientX + 15;
    }

    let rect = ref.current.getBoundingClientRect();
    if (rect.width + clientX > window.innerWidth) {
        return clientX - 15 - rect.width;
    }

    return clientX + 15;
};

export default function SeatPopover({ seat, getLabel, popover: Popover }) {
    const ref = React.useRef(null);

    React.useEffect(() => {
        if (!ref.current) {
            return;
        }

        const moveRef = ({ clientX, clientY }) => {
            let top = _top({ clientY, ref });
            let left = _left({ clientX, ref });
            ref.current.style.top = `${top}px`;
            ref.current.style.left = `${left}px`;
        };

        window.addEventListener('mousemove', moveRef);

        return () => window.removeEventListener('mousemove', moveRef);
    }, [ref]);

    let popoverProps = {
        seat,
        getLabel,
    };

    return (
        <div ref={ref} className="seatmap-seat-popover">
            {seat ? (
                Popover && typeof Popover !== 'string' ? (
                    React.isValidElement(Popover) ? (
                        React.cloneElement(Popover, {
                            ...Popover.props,
                            ...popoverProps,
                        })
                    ) : (
                        <Popover {...popoverProps} />
                    )
                ) : (
                    <div className="seatmap-seat-modal">{getLabel(seat, Popover)}</div>
                )
            ) : null}
        </div>
    );
}

SeatPopover.defaultProps = {
    seat: null,
    getLabel: ({ access, row, seat }, Popover) => {
        if (Popover && typeof Popover === 'string') {
            return Popover;
        }

        return `Access ${access} Row ${row} Seat ${seat}`;
    },
};

SeatPopover.propTypes = {
    coords: PropTypes.shape({
        clientX: PropTypes.number.isRequired,
        clientY: PropTypes.number.isRequired,
    }).isRequired,
    seat: PropTypes.object,
    getLabel: PropTypes.func,
    popover: PropTypes.oneOf([PropTypes.node, PropTypes.func]),
};
